import { useRepositoryQuery } from '@mews-commander/data-access';
import { useHasSwedishIntegrationEnabled } from './useHasSwedishIntegrationEnabled';

interface SwedishCashRegister {
    integrationId?: string;
}

export function useGetSwedishCashRegister(params: SwedishCashRegister = {}) {
    const { data } = useHasSwedishIntegrationEnabled();
    const integrationId = params.integrationId ?? data[0]?.id;

    return useRepositoryQuery(
        'swedishCashRegisters',
        'getAll',
        {
            integrationId,
        },
        {
            enabled: !!integrationId,
        }
    );
}
